import { Box, Stack } from '@mui/material';
import React from 'react';

import type { StatusChipType } from '../StatusChip';
import StatusChip from '../StatusChip';
import { MobileCaption, MobileSubtitle } from '../Typography';

export interface BoxItemProps {
  primaryText: string;
  amount: string | number;
  secondaryText?: string;
  chipText?: string;
  chipType?: StatusChipType;
  onClick?: () => void;
}

const BoxItem: React.FC<BoxItemProps> = ({
  primaryText,
  amount,
  secondaryText,
  chipText,
  chipType = 'default',
  onClick,
}) => {
  const showChip = chipText != null && chipText !== '';

  const handleClick = onClick ?? (() => {});

  return (
    <Box
      component="button"
      type="button"
      onClick={handleClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        border: 'none',
        borderRadius: 0,
        p: 0,
        py: 1.5,
        backgroundColor: 'transparent',
        cursor: 'pointer',
        textAlign: 'left',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
        '&:not(:first-of-type)': {
          borderTop: 1,
          borderColor: 'divider',
        },
      }}
    >
      <Box sx={{ minWidth: 0, display: 'flex', alignItems: 'flex-start' }}>
        <Stack spacing={0.25}>
          {showChip && (
            <Box sx={{ alignSelf: 'flex-start' }}>
              <StatusChip text={chipText} type={chipType} />
            </Box>
          )}
          <MobileSubtitle
            component="span"
            sx={{ fontSize: '1rem', fontWeight: 600, color: 'text.primary' }}
          >
            {primaryText}
          </MobileSubtitle>
          {secondaryText != null && secondaryText !== '' && (
            <MobileCaption
              component="span"
              sx={{ color: 'text.secondary', fontWeight: 400 }}
            >
              {secondaryText}
            </MobileCaption>
          )}
        </Stack>
      </Box>
      <MobileSubtitle
        component="span"
        sx={{
          flexShrink: 0,
          ml: 2,
          color: 'text.primary',
          fontSize: '1rem',
        }}
      >
        {amount}
      </MobileSubtitle>
    </Box>
  );
};

export default BoxItem;
